<template>
  <div class="user-billing-info">
    <div class="header">
      <h1>Company & Billing Information</h1>
      <div class="step-badge">
        Step 5/5
      </div>
    </div>

    <!-- ValidationObserver added for programmatic validate() -->
    <validation-observer ref="observer" v-slot="{ validate }">
      <div class="form-container">
        <h2>Company Information</h2>

        <div class="form-row">
          <div class="form-group">
            <label for="firstName"
            >First Name <span class="required">*</span></label
            >
            <BaseInput
              class="w-100"
              v-model="companyBillingInfo.firstName"
              :rules="{ required: true }"
              name="First Name"
              placeholder="First Name"
              type="text"
              id="firstName"
              required
            />
          </div>
          <div class="form-group">
            <label for="lastName"
            >Last Name <span class="required">*</span></label
            >
            <BaseInput
              class="w-100"
              v-model="companyBillingInfo.lastName"
              :rules="{ required: true }"
              name="Last Name"
              placeholder="Last Name"
              type="text"
              id="lastName"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="email"
            >Email Address <span class="required">*</span></label
            >
            <BaseInput
              class="w-100"
              v-model="companyBillingInfo.email"
              :rules="{ required: true }"
              name="Email address"
              placeholder="Email Address"
              type="email"
              id="email"
              @blur="checkEmail"
            />
            <small v-if="emailError" class="text-danger">{{ emailError }}</small>
          </div>
          <div class="form-group">
            <label for="phone"
            >Phone Number <span class="required">*</span></label
            >

            <BaseInput
              type="tel"
              id="phone"
              v-model="companyBillingInfo.phone"
              placeholder="Phone Number"
              :rules="{ required: true }"
              name="Phone Number"
              @input="acceptNumber"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="companyName"
            >Company Name <span class="required">*</span></label
            >
            <BaseInput
              class="w-100"
              v-model="companyBillingInfo.companyName"
              :rules="{ required: true }"
              name="Company name"
              placeholder="Company Name"
              type="text"
              id="companyName"
            />
          </div>
          <div class="form-group">
            <label for="phone">Company Logo</label>

            <BaseInput
              type="text"
              id="companyLogo"
              v-model="companyBillingInfo.companyLogo"
              placeholder="Company logo URL or identifier"
            />
          </div>
        </div>

        <!--        <h2>Billing Details</h2>-->

        <h2>Payment Details</h2>
        <div class="d-flex flex-column gap-4">
          <!-- Payment ACH -->
          <div
            class="border rounded-4" @click="paymentType = 'ach'"
            :class="{ 'payment-block-wrap': paymentType == 'ach' }"
          >
            <div
              :class="{ 'payment-header': paymentType == 'ach' }"
              class="d-flex justify-content-between align-items-center p-3"
            >
              <div class="left d-flex align-items-center">
                <input
                  type="radio"
                  id="Ach"
                  name="paymentType"
                  value="ach"
                  v-model="paymentType"
                />
                <h6 class="fw-bold m-0 pl-2">ACH</h6>
              </div>
            </div>
            <div class="payment-body p-3 mb-3" v-if="paymentType === 'ach'">
              <div class="d-flex align-items-center mb-3 gap-4">
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="paymenttype1"
                    value="monthly"
                    :checked="localBillingCycle === 'monthly'"
                    @change="localBillingCycle = $event.target.value"
                  />

                  Monthly ({{ formatNumber(totals.total_monthly_cost) }})
                </div>
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    value="yearly"
                    name="paymenttype1"
                    :checked="localBillingCycle === 'yearly'"
                    @change="localBillingCycle = $event.target.value"
                  />
                  Yearly ({{ formatNumber(totals.total_annually_cost) }})
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-control-label"
                  >Transit Number / ABA Routing Number
                    <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="transit_number"
                    placeholder="Transit Number / ABA Routing Number"
                    rules="required"
                    v-model="ACH.transit_number"
                  />
                </div>
                <div class="form-group">
                  <label class="form-control-label"
                  >Account Number <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="account_number"
                    placeholder="Account Number"
                    rules="required"
                    v-model="ACH.account_number"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-control-label"
                  >Financial Institution <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="financial_instituation"
                    placeholder="Financial Institution"
                    rules="required"
                    v-model="ACH.financial_instituation"
                  />
                </div>
                <div class="form-group">
                  <label class="form-control-label"
                  >Address <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="Address"
                    placeholder="Address"
                    rules="required"
                    v-model="companyBillingInfo.address_1"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-control-label"
                  >City <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="City"
                    placeholder="city"
                    rules="required"
                    v-model="companyBillingInfo.city"
                  />
                </div>
                <div class="form-group">
                  <label class="form-control-label"
                  >State <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="State"
                    placeholder="State"
                    rules="required"
                    v-model="companyBillingInfo.state"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-control-label"
                  >Zip code <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="number"
                    name="Zip code"
                    placeholder="Zip"
                    rules="required"
                    v-model="companyBillingInfo.zip"
                  />
                </div>
                <div class="form-group">
                  <label class="form-control-label"
                  >Branch <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="branch"
                    placeholder="Branch"
                    rules="required"
                    v-model="ACH.branch"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <div class="text-center mt-4">
                  <base-button
                    type="primary"
                    class="primary-orange border-0 mx-auto py-2 rounded-3"
                    :disabled="isProcessing"
                    @click="() => submitForm()"
                  >
                    <span v-if="isProcessing">Processing...</span>
                    <span v-else>Pay Now</span>
                  </base-button>
                </div>
              </div>
            </div>
          </div>
          <!-- Payment On Credit Card -->
          <div
            class="border rounded-4" @click="paymentType = 'creditCard'"
            :class="{ 'payment-block-wrap': paymentType == 'creditCard' }"
          >
            <div
              :class="{ 'payment-header': paymentType == 'creditCard' }"
              class="d-flex justify-content-between align-items-center p-3"
            >
              <div class="left d-flex align-items-center" style="cursor: pointer">
                <input
                  type="radio"
                  id="creditCard"
                  name="paymentType"
                  value="creditCard"
                  v-model="paymentType"
                />
                <h6 class="fw-bold m-0 pl-2">Credit card</h6>
              </div>
              <div class="right">
                <ul class="list-unstyled m-0 p-0 d-flex gap-2">
                  <li><img src="/img/price/payment1.svg" alt="Visa"/></li>
                  <li><img src="/img/price/payment2.svg" alt="Mastercard"/></li>
                  <li>
                    <img src="/img/price/payment3.svg" alt="American Express"/>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="payment-body p-3 mb-3"
              v-show="paymentType === 'creditCard'"
            >
              <div class="row">
                <div class="d-flex align-items-center gap-4 mb-2">
                  <div class="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      name="paymenttype2"
                      value="monthly"
                      :checked="localBillingCycle === 'monthly'"
                    @change="localBillingCycle = $event.target.value"
                    />
                    Monthly ({{ formatNumber(totals.total_monthly_cost) }})
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <input
                      type="radio"
                      value="yearly"
                      name="paymenttype2"
                      :checked="localBillingCycle === 'yearly'"
                    @change="localBillingCycle = $event.target.value"
                    />
                    Yearly ({{ formatNumber(totals.total_annually_cost) }})
                  </div>
                </div>
                <div class="col-12">

                  <div class="form-row">
                    <div class="form-group">
                      <label for="address">Address <span class="required">*</span></label>
                      <BaseInput
                        type="text"
                        id="address"
                        v-model="companyBillingInfo.address_1"
                        placeholder="Address"
                        :rules="{ required: true }"
                        name="Address"
                      />
                    </div>
                    <div class="form-group">
                      <label for="city">City <span class="required">*</span></label>
                      <BaseInput
                        type="text"
                        id="city"
                        v-model="companyBillingInfo.city"
                        placeholder="City"
                        :rules="{ required: true }"
                        name="City"
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <label for="state">State <span class="required">*</span></label>
                      <BaseInput
                        type="text"
                        id="state"
                        v-model="companyBillingInfo.state"
                        placeholder="State"
                        :rules="{ required: true }"
                        name="State"
                      />
                    </div>
                    <div class="form-group">
                      <label for="zipCode">Zip code <span class="required">*</span></label>
                      <BaseInput
                        type="text"
                        id="zipCode"
                        v-model="companyBillingInfo.zip"
                        placeholder="Zip code"
                        :rules="{ required: true }"
                        name="Zip code"
                      />
                    </div>
                  </div>
                  <div class="my-3">
                    <input
                      type="text"
                      class="form-control rounded-4"
                      placeholder="Name on card"
                      v-model="cardInfo.nameOnCard"
                      :rules="{ required: true }"
                      name="Name on card"
                    />
                  </div>
                </div>
                <span class="mb-3">
                  <!-- Stripe Element   -->
                  <stripe-element-card
                    ref="paymentRef"
                    :pk="publicKey"
                    v-if="paymentType === 'creditCard'"
                    @token="handleTokenCreated"
                  />
                  <!-- End Stripe Element   -->
                </span>
                <div class="d-flex justify-content-center">
                  <div class="text-center mt-2">
                    <base-button
                      type="primary"
                      class="primary-orange border-0 mx-auto py-2 rounded-3"
                      :disabled="isProcessing"
                      @click="() => submitForm()"
                    >
                      <span v-if="isProcessing">Processing...</span>
                      <span v-else>Pay Now</span>
                    </base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Payment Invoice -->
          <div
            class="border rounded-4" @click="paymentType = 'invoice'"
            :class="{ 'payment-block-wrap': paymentType == 'invoice' }"
          >
            <div
              :class="{ 'payment-header': paymentType == 'invoice' }"
              class="d-flex justify-content-between align-items-center p-3"
            >
              <div class="left d-flex align-items-center">
                <input
                  type="radio"
                  id="invoice"
                  name="paymentType"
                  value="invoice"
                  v-model="paymentType"

                />
                <h6 class="fw-bold m-0 pl-2" for="invoice">
                  Payment using Invoice (Additional 10%)
                </h6>
              </div>
            </div>
            <div class="payment-body p-3 mb-3" v-if="paymentType === 'invoice'">
              <div class="d-flex align-items-center gap-4 mb-2">
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    name="paymenttype3"
                    value="monthly"
                    :checked="localBillingCycle === 'monthly'"
                    @change="localBillingCycle = $event.target.value"
                  />
                  Monthly ({{ formatNumber(totals.total_monthly_cost) }})
                </div>
                <div class="d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    value="yearly"
                    name="paymenttype3"
                    :checked="localBillingCycle === 'yearly'"
                    @change="localBillingCycle = $event.target.value"
                  />
                  Yearly ({{ formatNumber(totals.total_annually_cost) }})
                </div>
              </div>
              <div class="">
                <div class="form-group">
                  <label class="form-control-label"
                  >Name of Recipient <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="invoice_name"
                    placeholder="Invoice Name"
                    rules="required"
                    v-model="Invoice.invoice_name"
                  />
                </div>
                <div class="form-group">
                  <label class="form-control-label"
                  >2. Recipient email address ( email1@gmail.com,
                    email2@gmail.com) <span class="required"> *</span></label
                  >
                  <BaseInput
                    type="text"
                    name="invoice_emails"
                    placeholder="Invoice Emails"
                    rules="required"
                    v-model="Invoice.invoice_emails"
                  />
                </div>
                <div class="form-group">
                  <label class="form-control-label"
                  >Phone <span class="required"> *</span></label
                  >
                  <BaseInput
                    name="Phone Number"
                    placeholder="Phone"
                    rules="required"
                    v-model="companyBillingInfo.telephone_no"
                    @input="acceptNumber"
                  />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label for="address">Address <span class="required">*</span></label>
                    <BaseInput
                      type="text"
                      id="address"
                      v-model="companyBillingInfo.address_1"
                      placeholder="Address"
                      :rules="{ required: true }"
                      name="Address"
                    />
                  </div>
                  <div class="form-group">
                    <label for="city">City <span class="required">*</span></label>
                    <BaseInput
                      type="text"
                      id="city"
                      v-model="companyBillingInfo.city"
                      placeholder="City"
                      :rules="{ required: true }"
                      name="City"
                    />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label for="state">State <span class="required">*</span></label>
                    <BaseInput
                      type="text"
                      id="state"
                      v-model="companyBillingInfo.state"
                      placeholder="State"
                      :rules="{ required: true }"
                      name="State"
                    />
                  </div>
                  <div class="form-group">
                    <label for="zipCode">Zip code <span class="required">*</span></label>
                    <BaseInput
                      type="text"
                      id="zipCode"
                      v-model="companyBillingInfo.zip"
                      placeholder="Zip code"
                      :rules="{ required: true }"
                      name="Zip code"
                    />
                  </div>
                </div>
                <div class="text-center mt-4">
                  <base-button
                    type="primary"
                    class="primary-orange border-0 mx-auto py-2 rounded-3"
                    :disabled="isProcessing"
                    @click="() => submitForm()"
                  >
                    <span v-if="isProcessing">Processing...</span>
                    <span v-else>Pay Now</span>
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {ValidationObserver} from "vee-validate";
import {StripeElementCard} from "@vue-stripe/vue-stripe";
import BaseInput from "../Inputs/BaseInput.vue";
import BaseButton from "../BaseButton.vue";

export default {
  name: "CompanyBillingInfo",
  props: {
    choosePlatform: {
      type: String,
      default: null,
    },
    isChoosePlatform: {
      type: Function,
      required: true,
    },
    totals: {
      type: Object,
      default: () => ({
        total_monthly_cost: 0,
        total_annually_cost: 0,
      }),
    },
  },
  components: {
    BaseInput,
    StripeElementCard,
    BaseButton,
    ValidationObserver,
  },
  data() {
    return {
      submitted: false,
      active: 0,
      freeTrail: false,
      localBillingCycle: 'monthly',
      companyBillingInfo: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        companyName: "",
        companyLogo: "",
        address_1: "",
        city: "",
        state: "",
        zip: "",
        telephone_no: "",
      },

      cardInfo: {
        nameOnCard: "",
        stripe_token: null,
      },
      card: {
        paymentType: "monthly",
      },
      paymentObjects: {
        paymentMethod: "monthly",
      },
      ACH: {
        accountType: "checking",
        branch: "",
        account_number: "",
        transit_number: "",
        financial_instituation: "",
      },
      contact: {
        name: "",
        phone: "",
        email: "",
        message: "",
      },
      Invoice: {
        invoice_name: "",
        invoice_emails: "",
        invoice_phone: "",
        invoice_address: "",
        invoice_city: "",
        invoice_state: "",
      },
      paymentType: "ach",
      billingCycle: "monthly",
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY ||
        "pk_test_51No6OFL15lkUCZa9hyptqlC7lT0PblOHy62Mu9yb8PfW2oaGrIcjGcbXZtvtLi8tPVtpeE4qCTMxgic6uBX1O60t002oASCfye",
      postalCode: true,
      // new state
      isProcessing: false,
      emailVerified: false,
      emailError: "",
      formErrors: {},
    };
  },
  watch: {
    companyBillingInfo: {
      handler() {
        if (this._billingUpdateTimeout) clearTimeout(this._billingUpdateTimeout);
        this._billingUpdateTimeout = setTimeout(() => {
          this.$emit('billing-update', { ...this.companyBillingInfo });
        }, 800);
      },
      deep: true,
    },
    localBillingCycle(newVal) {
      this.updateBillingCycle(newVal);
    },
  },
  methods: {
    updateBillingCycle(cycle) {
      this.$emit("change-billing-cycle", cycle);
    },
    async checkEmail() {
      if (!this.companyBillingInfo.email) return;
      // basic format check first
      if (!this.validateEmail(this.companyBillingInfo.email)) {
        this.emailError = "Please enter a valid email address.";
        this.emailVerified = false;
        return;
      }

      try {
        const resp = await this.$http.post("user/valid-email", {
          email: this.companyBillingInfo.email,
        });

        if (resp && resp.data && resp.data.status) {
          this.formErrors.email = "";
          this.emailError = "";
          this.emailVerified = true;
        } else {
          const message = resp && resp.data && resp.data.message
            ? resp.data.message
            : "Email is invalid or already taken.";
          this.formErrors.email = message;
          this.emailError = message;
          this.emailVerified = false;
        }
      } catch (err) {
        this.emailVerified = false;
        this.formErrors.email = "Email validation failed.";
        this.emailError = "Email validation failed.";
      }
    },

    // Form-level entry point when user clicks "Pay Now" for any payment type
    async submitForm() {
      this.formErrors = {};
      this.emailError = "";

      let isValid = true;
      if (this.$refs.observer && this.$refs.observer.validate) {
        const res = await this.$refs.observer.validate();
        isValid = res;
      } else {
        isValid = this.isFormValid;
      }

      if (!isValid) {
        this.$toast?.error
          ? this.$toast.error("Please fill all required fields.", {timeout: 5000})
          : null;
        return;
      }

      if (!this.emailVerified) {
        await this.checkEmail();
        if (!this.emailVerified) {
          this.formErrors.email = this.emailError || "Please verify your email first.";
          return;
        }
      }
      if (this.paymentType === "creditCard") {
        this.$refs.paymentRef.submit();
      } else if (this.paymentType === "ach") {
        if (
          !this.ACH.transit_number ||
          !this.ACH.account_number ||
          !this.ACH.financial_instituation
        ) {
          this.$toast?.error
            ? this.$toast.error("Please fill all required ACH fields", {timeout: 5000})
            : null;
          return;
        }
        this.isProcessing = true
        this.$emit("form-submitted", this.collectPayload());
      } else if (this.paymentType === "invoice") {
        // ensure invoice fields present
        if (!this.Invoice.invoice_name || !this.Invoice.invoice_emails) {
          this.$toast?.error
            ? this.$toast.error("Please fill all required invoice fields")
            : null;
          return;
        }
        this.isProcessing = true
        this.$emit("form-submitted", this.collectPayload());
      }
    },
    handleTokenCreated(token) {
      this.cardInfo.stripe_token = token;
      this.continueSubmit();
    },


    continueSubmit() {
      if (!this.cardInfo?.stripe_token) {
        this.formErrors.stripe = "Failed to generate Stripe token.";
        this.isProcessing = false;
        return;
      }
      this.isProcessing = true;
      this.$emit("form-submitted", this.collectPayload());
    },

    collectPayload() {
      return {
        form: {
          companyBillingInfo: {...this.companyBillingInfo},
          cardInfo: {...this.cardInfo},
          paymentType: this.paymentType,
          billingCycle: this.billingCycle,
          ACH: {...this.ACH},
          Invoice: {...this.Invoice},
        }
      };
    },

    acceptNumber() {
      let x = (this.companyBillingInfo.phone || "")
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.companyBillingInfo.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },

    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    formatPrice(price) {
      return price ? `$${parseFloat(price).toFixed(2)}` : "$0.00";
    },
    formatNumber(num) {
      if (!num && num !== 0) return "0";
      return parseFloat(num).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
  },
  computed: {
    isFormValid() {
      return (
        this.companyBillingInfo.firstName &&
        this.companyBillingInfo.lastName &&
        this.companyBillingInfo.email &&
        this.validateEmail(this.companyBillingInfo.email) &&
        this.companyBillingInfo.phone &&
        this.companyBillingInfo.address_1 &&
        this.companyBillingInfo.city &&
        this.companyBillingInfo.state &&
        this.companyBillingInfo.zip
      );
    },
  },
};
</script>


<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.user-billing-info {
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

h1 {
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
  color: #252525;
  margin: 0;
}

.step-badge {
  position: absolute;
  right: 0;
  top: -7px;
  background: #fff0ea;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 23px;
  font-weight: 700;
  color: #252525;
}

.form-container {
  border: 1px solid rgba(235, 26, 38, 0.2);
  padding: 20px 12px;
  border-radius: 15px;
}

h2 {
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  color: #252525;
  margin-top: 0;
  margin-bottom: 20px;
}

.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  flex-direction: column;
}

:deep(.form-control-label) {
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  margin-bottom: 12px;
  color: #252525;
}

:deep(.form-control) {
  border: 1px solid rgba(37, 37, 37, 0.1);
  border-radius: 12px;
}

label {
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  margin-bottom: 12px;
  color: #252525;
}

.required {
  color: #ff5252;
}

input {
  height: 48px;
  padding: 0 16px;
  border: 1px solid rgba(37, 37, 37, 0.1);
  border-radius: 12px;
  font-size: 16px;
  transition: border-color 0.2s;
}

input:focus {
  outline: none;
  border-color: #4a90e2;
}

input.error {
  border-color: #ff5252;
}

.form-actions {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.submit-button {
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-button:hover {
  background-color: #3a7bc8;
}

.payment-block-wrap {
  border: 1px solid rgba(37, 37, 37, 0.1) !important;
  border-radius: 12px !important;
}

.payment-header {
  border-bottom: 1px solid rgba(37, 37, 37, 0.1) !important;
}

.payment-header .left {
  display: flex;
  align-items: center;
}

.payment-header .left input[type="radio"] {
  margin-right: 10px;
  height: 20px;
  width: 20px;
}

.payment-header .left h6 {
  margin-left: 10px;
}

.payment-header .right ul {
  display: flex;
  gap: 10px;
}

.payment-header .right ul li img {
  height: 24px;
}

.primary-orange {
  background-color: #eb1a26 !important;
  color: white;
}

@media (min-width: 768px) {
  .user-billing-info {
    margin-top: 60px;
  }

  h1 {
    font-size: 32px;
    line-height: 40px;
  }
  .step-badge {
    position: absolute;
    right: 0;
    top: 0;
    background: #fff0ea;
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 18px;
    line-height: 23px;
    font-weight: 700;
    color: #252525;
  }
  .form-container {
    padding: 20px;
  }
  .form-row {
    flex-direction: row;
    gap: 20px;
  }
  label {
    font-size: 15px;
    font-weight: 700;
    line-height: 19px;
    margin-bottom: 12px;
  }
  :deep(.form-control-label) {
    font-size: 15px;
    font-weight: 700;
    line-height: 19px;
    margin-bottom: 12px;
  }
}
</style>
